<script setup>
import { storeToRefs } from 'pinia';
import { useStandingStore } from '../stores/standing-store';

/**
 * Standing
 */
const { standing, loading } = storeToRefs(useStandingStore());
</script>

<template>
  <ul class="nav nav-underline mb-3 flex-nowrap overflow-x-auto" v-if="!loading && standing">
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'standing.detail',
          params: { standingId: standing.id },
        }"
        class="nav-link"
      >
        About
      </RouterLink>
    </li>
  </ul>
</template>

<style scoped>
.nav-item a {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.standing-nav a:hover {
  border-bottom: 3px solid var(--bs-primary);
}
.nav-link {
  border-bottom: 3px solid transparent;
}
.router-link-exact-active {
  border-bottom: 3px solid var(--bs-primary);
}


</style>
